var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-circle"},[_c('vue-circle',{attrs:{"progress":_vm.val,"size":45,"reverse":false,"line-cap":"round","fill":_vm.fill,"empty-fill":"#ffffff","animation-start-value":0.0,"start-angle":0,"insert-mode":"append","thickness":6,"show-percent":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }